<template>
  <div class="col-12 col-md order-1 order-md-0">
    <div
      class="text-azul-medio text-uppercase gilmer h4 text-center mt-5 mt-md-3 font-weight-light"
    >
      &nbsp;
    </div>
    <div class="bg-azul-claro py-4 px-4 h6 text-center rounded">
      <div class="bg-azul-medio rounded py-4 text-white gilmer mx-0 mx-lg-3">
        Accede con tu
        <br />
        <strong>RUN</strong> o <strong>IPA</strong>,
        <strong>CONTRASEÑA</strong>
        <br />con la que te registraste como apoderado e ingresa el <br />
        <strong>RUN</strong> o <strong>IPE DE TU POSTULANTE</strong> <br />
        para descargar el comprobante deseado.
      </div>
    </div>
    <div class="bg-azul-claro py-3 px-4 h6 text-center rounded mt-5 mt-lg-3">
      <a :href="ayuda" target="_blank" class="gilmer h5 font-weight-light">
        <strong class="d-inline-block">¿Tienes dudas?</strong>
        <span
          class="d-inline-block mt-2 text-uppercase font-weight-bold subrayado h6"
          >Consulta Ayuda Mineduc</span
        >
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "InformacionListaDeEspera",
  data() {
    return {
      ayuda: PLATAFORMA.AYUDA_OFIC_REGIONAL
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/InformacionListaDeEspera.vue